import { StyledProps, StyledPropsTheme } from '@my-types';
import { React, ReactDOM, Styled, StyledF } from '@common/3rd';
import { Envs } from '@common';
import Styles, { Phone } from '@styles';

const Wrapper = Styled.div.attrs({
	'data-widget': 'dialog-wrapper'
})`
	position: relative;
	display: ${(props: { shown?: boolean }) => (props.shown ? 'block' : 'none')};
`;

const Backdrop = Styled.div.attrs({
	'data-widget': 'dialog-backdrop'
})`
	display: block;
	position: fixed;
	width: 100vw;
	height: 100vh;
	top: 0;
	background-color: ${(props: any) => (props.grabQrCss ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.01)')};
	z-index: ${props => props.theme.DIALOG_Z_INDEX};
` as any;

const Box = Styled.div.attrs({
	'data-widget': 'dialog-box'
})`
	display: flex;
	flex-direction: column;
	position: fixed;
	top: ${(props: any) => props.boxCSS?.top || '10vh'};
	left: ${(props: any) => props.boxCSS?.width ? `calc(50vw - ${props.boxCSS?.width} / 2)` : '10vw'};
	max-height: 80vh;
	width: ${(props: any) => props.boxCSS?.width || '80vw'};
	border-radius: ${props => props.theme.BORDER_RADIUS}px;
	padding: ${props => props.theme.PANEL_PADDING}px ${props => props.theme.DESK_DIALOG_HORIZONTAL_PADDING}px;
	background: ${props => props.theme.PANEL_BACKGROUND_COLOR};
	z-index: ${props => props.theme.DIALOG_Z_INDEX + 1};
	box-shadow: ${props => props.theme.DIALOG_SHADOW};

	${Phone.only`
		padding: 0;
		// width: 90vw;
		// top: ${(props: any) => (props.grabTop ? '30vh' : '10vh')};;
		// left: 5vw;
		height: ${(props: any) => (props.grabHeight ? '80vh' : '')};
		width: ${(props: any) => (props.grabQrCss ? '60vw' : '90vw')};
		left: ${(props: any) => (props.grabQrCss ? '20vw' : '5vw')};
		top: ${(props: any) => (props.grabQrCss ? '25vh' : (props.grabTop ? '30vh' : '10vh'))};
	`}
` as any;

const Header = Styled.div.attrs({
	'data-widget': 'dialog-header'
})`
	display: flex;
	justify-content: flex-start;
	// border-bottom: ${props => props.theme.BORDER};
	// border-width: ${props => props.theme.BORDER_WIDTH * 3}px;
	// border-color: ${props => props.theme.COLOR_PRIMARY};
	overflow: hidden;
	min-height: ${props => props.theme.INPUT_HEIGHT + props.theme.BORDER_WIDTH * 2}px;
	${Phone.only`
		min-height: ${(props: StyledProps) => props.theme.ROW_HEIGHT}px;
	`}
	${(props: any) => {
		if (props.primary) {
			return `
				background-color: ${props.theme.COLOR_PRIMARY};
				color: ${props.theme.COLOR_REVERSED};
				border-top-left-radius: ${props.theme.BORDER_RADIUS}px;
				border-top-right-radius: ${props.theme.BORDER_RADIUS}px;
				border-bottom: 0;
			`;
		} else {
			return Phone.only`
				border-bottom: ${(props: StyledProps) => props.theme.BORDER_MINOR_LIGHT};
				border-width: ${(props: StyledProps) => props.theme.BORDER_WIDTH}px;
			`;
		}
	}}}
	& > div:nth-child(2) {
		cursor: pointer;
		font-size: 2em;
		color: #999;
		padding: 0 10px;
	}
	${(props: any) => (props.css ? props.css(props.theme) : '')}
` as any;

const Title = Styled.div.attrs({
	'data-widget': 'dialog-header-title'
})`
	flex-grow: 1;
	font-weight: ${props => props.theme.FONT_WEIGHT_BOLD};
	${Phone.only`
		font-weight: ${(props: StyledProps) => props.theme.FONT_WEIGHT_BOLD_LIGHT};
		padding: 0 ${(props: StyledProps) => props.theme.MOBILE_HTML_HORIZONTAL_MARGIN}px;
		height: ${(props: StyledProps) => props.theme.ROW_HEIGHT}px;
		line-height: ${(props: StyledProps) => props.theme.ROW_HEIGHT}px;
	`}
`;

const Body = Styled.div.attrs({
	'data-widget': 'dialog-body'
})`
	flex-grow: 1;
	display: flex;
	justify-content: flex-start;
	margin-bottom: ${props => props.theme.PANEL_PADDING}px;
	overflow: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	> * {
		flex-grow: 1;
	}

	${Phone.only`
		margin-bottom: 0;
	`}
`;
const Footer = Styled.div.attrs({
	'data-widget': 'dialog-footer'
})`
	display: flex;
	justify-content: space-around;
	min-height: ${props => props.theme.INPUT_HEIGHT + props.theme.BORDER_WIDTH * 2}px;
	overflow: hidden;
	${Phone.only`
		min-height: ${(props: StyledProps) => props.theme.ROW_HEIGHT}px;
	`}
	> [data-widget=mobile-btn-group] {
		> a {
			box-shadow: none;
			&:first-child {
				border-top-left-radius: 0;
				border-bottom-left-radius: ${props => props.theme.BORDER_RADIUS}px;
			}
			&:last-child {
				border-top-right-radius: 0;
				border-bottom-right-radius: ${props => props.theme.BORDER_RADIUS}px;
			}
			&:first-child:last-child {
				border-bottom-left-radius: ${props => props.theme.BORDER_RADIUS}px;
				border-bottom-right-radius: ${props => props.theme.BORDER_RADIUS}px;
				border-top-left-radius: 0;
				border-top-right-radius: 0;
			}
			
			&:not(:first-child):before {
				content: '';
				position: absolute;
				left: 0;
				top: 25%;
				width: 1px;
				height: 50%;
				border-left: ${props => props.theme.BORDER};
				border-color: ${props => props.theme.COLOR_REVERSED};
				opacity: 0.7;
			}
			&[type="waive"] + a:not([type="waive"]):before {
				display: none;
			}
		}
	}
`;

type DialogProps = {
	grabHeight?: boolean;
	boxCSS?: any;
	headerCSS?: (theme: StyledPropsTheme) => string; primaryHeader?: boolean;
	grabTop?: boolean;
	useBackDrop?: true
	grabQrCss?: true;
	closeBtn?: boolean;
};

/**
 * 对话框
 */
class Dialog extends React.Component<DialogProps> {
	state: {
		show?: boolean;
		title?: string;
		content?: any;
		footer?: any;
	} = {};
	renderHeader(): JSX.Element | null {
		if (this.state.title) {
			return (
				<Header css={this.getHeaderCSS()} primary={this.isPrimaryHeader()} key={'dialog-header'}>
					<Title>{this.state.title}</Title>
					{this.props.closeBtn ? null : <div onClick={this.close}>&times;</div>}
				</Header>
			);
		} else {
			return null;
		}
	}
	renderBody(): JSX.Element {
		return <Body key={'dialog-body'}>{this.state.content}</Body>;
	}
	renderFooter(): JSX.Element | null {
		if (this.state.footer) {
			return <Footer key={'dialog-footer'}>{this.state.footer}</Footer>;
		} else {
			return null;
		}
	}
	render(): JSX.Element {
		if (this.state.show) {
			return (
				<StyledF.ThemeProvider theme={Styles.getTheme(Envs.getCurrentTheme())}>
					<React.Suspense fallback={<div />}>
						<Wrapper shown={this.isShown()}>
							<Backdrop onClick={this.backdropClicked} grabQrCss={this.isGrabQrCss()} />
							<Box boxCSS={this.getBoxCSS()} grabHeight={this.isGrabHeight()} grabTop={this.isGrabTop()}
								grabQrCss={this.isGrabQrCss()} key={'dialog-container'}>
								{this.renderHeader()}
								{this.renderBody()}
								{this.renderFooter()}
							</Box>
						</Wrapper>
					</React.Suspense>
				</StyledF.ThemeProvider>
			);
		} else {
			return <div />;
		}
	}
	backdropClicked = () => {
		if (this.isUseBackDrop()) this.hide();
		return;
	}
	close = () => {
		this.hide();
	}
	show(title: string, content: any, footer?: any): this {
		// 去掉焦点, 实际上是为了在移动设备上去掉软键盘
		const active = document.activeElement as HTMLElement;
		active && active.blur();
		this.setState(
			{
				show: true,
				title,
				content,
				footer
			},
			() => {
				Envs.application()!.setScrollDisabled(true);
			}
		);
		return this;
	}
	/**
	 * 隐藏警告对话框, 默认resolve promise
	 */
	hide(): this {
		this.setState({
			show: false,
			title: undefined,
			content: undefined,
			footer: undefined
		});
		Envs.application()!.setScrollDisabled(false);
		return this;
	}
	isShown(): boolean {
		return this.state.show ? true : false;
	}
	isGrabHeight() {
		return this.props.grabHeight;
	}
	isPrimaryHeader() {
		return this.props.primaryHeader;
	}
	getHeaderCSS() {
		return this.props.headerCSS;
	}
	getBoxCSS() {
		return this.props.boxCSS;
	}
	isGrabTop() {
		return this.props.grabTop;
	}
	isGrabQrCss() {
		return this.props.grabQrCss === true;
	}
	isUseBackDrop() {
		return this.props.useBackDrop === true;
	}
}

let dialogIndex = 1;
class DialogHelper {
	show(title: string, content: any, footer?: any, options?: DialogProps): React.RefObject<Dialog> {
		let container = document.getElementById(`dialog-container-${dialogIndex}`);
		if (container == null) {
			container = document.createElement('DIV');
			container.id = `dialog-container-${dialogIndex}`;
			document.body.appendChild(container);
		}
		dialogIndex++;

		const dialogRef = React.createRef() as React.RefObject<Dialog>;
		ReactDOM.render(<Dialog ref={dialogRef} {...options} />, container);
		(dialogRef as any).current.show(title, content, footer);
		return dialogRef;
	}
	hide(ref: any): void {
		if (ref == null || ref.current == null) {
			return;
		}
		ref.current.hide();
		const dom = ReactDOM.findDOMNode(ref.current) as HTMLElement;
		// 必须先维持一下
		const parent = dom.parentNode;
		ReactDOM.unmountComponentAtNode(dom.parentElement!);
		document.body.removeChild(parent!);
	}
}

export default new DialogHelper();
